import React, { useMemo } from "react";
import { AnalyticsTimeSeriesResponse } from "../../../api/v2/types";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

interface AnalyticsTimeSeriesChartProps {
  timeseries: AnalyticsTimeSeriesResponse | null;
}

const AnalyticsTimeSeriesChart = ({ timeseries }: AnalyticsTimeSeriesChartProps) => {
  const data = useMemo(
    () =>
      (timeseries?.points || []).map((point) => ({
        date: new Date(point.bucketStart).toLocaleDateString(),
        value: point.value,
      })),
    [timeseries]
  );

  if (!data.length) {
    return <p className="text-sm text-muted-foreground">No activity points for selected range.</p>;
  }

  return (
    <div className="h-[260px] rounded border p-3">
      <p className="mb-2 text-sm font-semibold">Activity over time</p>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Area type="monotone" dataKey="value" stroke="#2563eb" fill="#93c5fd" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AnalyticsTimeSeriesChart;
